import * as React from "react";
import {OperatorProgression, AchievementConfig} from "../../../../generated/protocol";
import {LoadingViewState, RouterView} from "../RouterView";
import {AppCtx} from "../../../ioc/ApplicationContext";
import {
    OperatorProgressionService,
    OPERATOR_PROGRESSION_SERVICE_NAME
} from "../../../service/operator/OperatorProgressionService";
import {kernel} from "../../../ioc/IOCHelper";
import {ProgressButton} from "../../util/ProgressButton";
import {AchievementsService} from "../../../service/achievements/AchievementsService";
import {Symbols} from "../../../ioc/Symbols";


interface State extends LoadingViewState {
    progression?: OperatorProgression;
    achievements?: AchievementConfig[];
    operatorId?: number;
    inProgress?: boolean;
    inProgressNameId?: string;
}

export class TriggersActivationView extends RouterView<{}, State> {


    operatorProgressionService: OperatorProgressionService;

    achievementsService: AchievementsService;

    constructor(props) {
        super(props);
        this.operatorProgressionService = kernel.get<OperatorProgressionService>(OPERATOR_PROGRESSION_SERVICE_NAME);
        this.achievementsService = kernel.get<AchievementsService>(Symbols.AchievementsService);
        this.state = {operatorId: AppCtx.getUserStore().getState().activeOperator, inProgress: false};
    }

    loadContent(): Promise<any> {
        return this.loadAll(
            this.operatorProgressionService.getOperatorProgression(this.state.operatorId),
            this.achievementsService.list({offset: 0, limit: 200, ascending: false, orderBy: "nameId"})
        ).then(results => {
            this.setState({
                loading: false,
                progression: results[0],
                achievements: results[1].items
            });
        })
    }

    disableAchievement(l: AchievementConfig) {
        if (this.state.inProgress == true) return;

        this.setState({inProgress: true, inProgressNameId: l.nameId});

        this.achievementsService.disableAchievement(l.nameId, this.state.operatorId).then((prog) => {
            this.setState({progression: prog, inProgress: false});
        }).catch(err => {
            this.setState({inProgress: false});
        });
    }

    enableAchievement(l: AchievementConfig) {

        if (this.state.inProgress == true) return;

        this.setState({inProgress: true, inProgressNameId: l.nameId});

        this.achievementsService.enableAchievement(l.nameId, this.state.operatorId).then((prog) => {
            this.setState({progression: prog, inProgress: false, inProgressNameId: l.nameId});
        }).catch(err => {
            this.setState({inProgress: false});
        });
    }

    isInProgress(nameId) {

        if (this.state.inProgress == true && this.state.inProgressNameId == nameId) {
            return true;
        }
        return false;
    }

    isEnabled(achievement: AchievementConfig) {
        return this.state.progression.achievements.some(l => {
            return achievement.nameId == l
        });
    }

    getActionForAchievement(achievement: AchievementConfig) {
        var enabled = this.isEnabled(achievement);
        if (enabled) {
            return <ProgressButton inProgress={this.isInProgress(achievement.nameId)} className="btn btn-danger"
                                   onClick={this.disableAchievement.bind(this, achievement)}>Disable</ProgressButton>;
        } else {
            return <ProgressButton inProgress={this.isInProgress(achievement.nameId)} className="btn btn-primary"
                                   onClick={this.enableAchievement.bind(this, achievement)}>Enable</ProgressButton>;
        }
    }

    getAchievements(): any {
        if (this.state.achievements == null) {
            return false;
        }
        return this.state.achievements.map(l => {
            return (
                <tr key={l.id}>
                    <td>{this.isEnabled(l) ? <i className="fa fa-check text-navy"></i> :
                        <i className="fa fa-close text-danger"></i>}</td>
                    <td>{l.nameId}</td>
                    <td>{l.name}</td>
                    <td>{this.getActionForAchievement(l)}</td>
                </tr>
            );
        })
    }

    renderContent() {
        return (
            <div>
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col-lg-12">
                        <h1>Activate Triggers</h1>
                    </div>
                </div>
                <div className="wrapper wrapper-content animated">

                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>Striped Table </h5>
                        </div>
                        <div className="ibox-content">

                            <table className="table table-striped">
                                <thead>
                                <tr>
                                    <th>Status</th>
                                    <th>Id</th>
                                    <th>Name</th>
                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.getAchievements()}

                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/view/achievements/TriggersActivationView.tsx